/* eslint-disable no-use-before-define */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  DOCTORS,
  INFORMATION_PATH,
  LOGIN_PAGE_PATH,
  MY_TURN_PATH,
  NOTIFICATION_PATH,
  PROFILE_PATH,
  QUESTION_PATH,
  REGISTER_PAGE_PATH,
  TURNS_PATH
} from '../../routes/path';
import './index.scss';
import { logout } from '../../redux/actions/userActions';
import BurguerButton from '../burguerButton';
import Footer from '../footer';
import Logo from '../../assets/logo/logo.png';
import Tab from '../tab';

const NavigationMenu = ({ children }) => {
  const currentPath = window.location.pathname;
  const { user, isLoggedIn } = useSelector((state) => state.userReducer);
  const [navActive, setNavActive] = useState(false);
  const [showLogoutConfirmation, setShowLogoutConfirmation] = useState(false);
  const navigate = useNavigate();

  const handleNavItemClicked = (item, navigateTo) => {
    if (navActive) {
      setNavActive(false);
    }
    navigate(navigateTo);
  };

  let baseNavigation = [{
    navigateTo: INFORMATION_PATH,
    onClick: handleNavItemClicked,
    name: 'Inicio',
  },
  {
    navigateTo: `${TURNS_PATH}${DOCTORS}`,
    onClick: handleNavItemClicked,
    name: 'Reservar turno',
  },
  {
    navigateTo: NOTIFICATION_PATH,
    onClick: handleNavItemClicked,
    name: 'Notificaciones',
  },
  ];

  const optionUser = [
    {
      navigateTo: LOGIN_PAGE_PATH,
      onClick: handleNavItemClicked,
      name: 'Iniciar sesión',
    },
    {
      navigateTo: REGISTER_PAGE_PATH,
      onClick: handleNavItemClicked,
      name: 'Registro',
    }
  ];

  const userProfile = [
    {
      navigateTo: PROFILE_PATH,
      onClick: handleNavItemClicked,
      isActive: false,
      name: `${user?.nombre} ${user?.apellido}`,
    }
  ];

  const currentProfileOption = userProfile.find((tab) => tab.navigateTo === currentPath);

  const currentTabOption = optionUser.find((tab) => tab.navigateTo === currentPath);

  const redirect = () => {
    navigate(`${PROFILE_PATH}`);
  };

  const handleNavToggle = () => {
    setNavActive(!navActive);
  };
  const handleLogoutLinkClick = () => {
    setShowLogoutConfirmation(true);
  };
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
    setShowLogoutConfirmation(false);
    navigate(INFORMATION_PATH);
  };

  if (isLoggedIn) {
    baseNavigation = [
      ...baseNavigation,
      {
        navigateTo: MY_TURN_PATH,
        onClick: handleNavItemClicked,
        isActive: false,
        name: 'Mis Turnos',
      },
      {
        navigateTo: QUESTION_PATH,
        onClick: handleNavItemClicked,
        isActive: false,
        name: 'Preguntas',
      },
    ];
  }

  const allTabs = [...baseNavigation, ...optionUser, ...userProfile];
  const currentTab = allTabs.find((tab) => tab.navigateTo.split('/')[1] === currentPath.split('/')[1]);

  return (
    <>
      {showLogoutConfirmation && (
      <div className="popup">
        <div className="popup-content">
          <h2>¿Está seguro de que desea cerrar sesión?</h2>
          <div className="popup-buttons">
            <button className="confirm" onClick={handleLogout}>Sí</button>
            <button className="cancel" onClick={() => setShowLogoutConfirmation(false)}>No</button>
          </div>
        </div>
      </div>
      )}
      <nav className="navigation-menu ">
        <ul className={`ul-solo ${navActive ? 'active' : ''}`}>
          <div className="not">
            <li>
              <div className={`div-ul  ${navActive ? 'active' : ''} nothover`}>
                <img src={Logo} alt="" width="40px" />
              </div>
            </li>
            {baseNavigation.map((item) => (
              <Tab
                key={item.name}
                currentTab={currentTab?.name}
                {...item}
              />
            ))}
          </div>
          <div className="not active">
            {
              isLoggedIn ? (
                <>
                  <li>
                    <div
                      // className={`div-ul ${navActive ? 'active' : ''} `}
                      onClick={redirect}
                      onKeyDown={() => { }}
                      role="button"
                      tabIndex={0}
                    >
                      {userProfile.map((item) => (
                        <Tab
                          key={item.name}
                          currentTab={currentProfileOption?.name}
                          {...item}
                        />
                      ))}
                    </div>
                  </li>
                  <li>
                    <div
                      className={`div-ul ${navActive ? 'active' : ''}`}
                      onClick={handleLogoutLinkClick}
                      onKeyDown={() => { }}
                      role="button"
                      tabIndex={0}
                    >
                      Cerrar sesión
                    </div>

                  </li>

                </>
              ) : (
                <>
                  {optionUser.map((item) => (
                    <Tab
                      key={item.name}
                      currentTab={currentTabOption?.name}
                      {...item}
                    />
                  ))}
                </>
              )
            }

          </div>
        </ul>
        <div className="bg-button">
          <div className="hola">
            <img src={Logo} alt="" width="50px" height="50px" />
            <BurguerButton clicked={navActive} handleClick={handleNavToggle} />
          </div>
        </div>
      </nav>
      <div className={`body  children ${navActive ? '' : ''}`}>
        {children}
      </div>
      <Footer />

    </>
  );
};

NavigationMenu.propTypes = {
  children: PropTypes.node.isRequired,
};

export default NavigationMenu;
